<prlw-main-table-header-ui
  [columns]="columns$ | async"
  [sorting]="sorting$ | async"
  [gridSize]="gridSize$ | async"
  [preloaderActive]="preloaderActive$ | async"
  [reqInstrumentsResult]="reqInstrumentsResult$ | async"
  [isModifiersOverlayOpen]="isModifiersOverlayOpen$ | async"
  [isModifierChanged]="isModifierChanged$ | async"
  (sortColumn)="sortColumn($event)"
  (openModifiersOverlay)="openModifiersOverlay()"
  (eventUpdateColumns)="handleUpdateColumns($event)"
  prlwResponsive
></prlw-main-table-header-ui>
